import { Footnote } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const MobileFootnote = styled(Footnote)`
  font-style: italic;
  margin-top: 185px;
  margin-bottom: 0px;
  text-align: center;
  display: none;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: inline;
    position: absolute;
    bottom: 30px;
    margin-left: 30px;
    margin-right: 30px;
  }
`
